import type { LucideIcon } from 'lucide-react';

interface EmptyBlockProps {
  icon: LucideIcon;
  title: string;
  description: string;
}

/** The product's empty state (AgencyDetail's empty tables): an icon in a circle, a title and one line. */
export function EmptyBlock({ icon: Icon, title, description }: EmptyBlockProps) {
  return (
    <div className="flex flex-col items-center justify-center">
      <div className="mx-auto w-12 h-12 rounded-full bg-muted flex items-center justify-center mb-4">
        <Icon className="h-6 w-6 text-muted-foreground" />
      </div>
      <h3 className="text-lg font-medium mb-2">{title}</h3>
      <p className="text-sm text-muted-foreground">{description}</p>
    </div>
  );
}
